import React, { useEffect, useState } from 'react';
import { RegisterPageContent } from 'services/content';
import { checkCircleGreen, hpPromo } from 'assets';
import styles from './style.module.css';
import { WELCOME_GET_STARTED, NHS_LOGIN_REGISTRATION_START } from 'helpers/monitoringEvents';
import { useAnalytics, useMonitoringEvents } from 'hooks';
import { SET_CODE_VERIFIER, SET_AUTH_STATE } from 'helpers/types';
import { useDispatch } from 'react-redux';
import { NHS_VTR_CODE_P5, NHS_VTR_CODE_P9 } from 'helpers/nhsLogin';
import PropTypes from 'prop-types';
import { AlertMessage, NHSLogo, Spinner } from 'components';

const Register = ({ isP9 }) => {
  const [postLog] = useMonitoringEvents();
  const [challenge, setChallenge] = useState(false);
  const [authState, setAuthState] = useState(false);
  const [loadingRedirect, setLoadingRedirect] = useState(false);
  const dispatch = useDispatch();
  const crypto = require('crypto');
  const redirectDelay = 3000;
  const [postFloodlight] = useAnalytics();
  postFloodlight({ code: 'heyph000' });

  useEffect(() => {
    postLog(WELCOME_GET_STARTED);
  }, [postLog]);

  useEffect(() => {
    const base64URLEncode = (str) => str.toString('base64').replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');

    const verifier = base64URLEncode(crypto.randomBytes(32));

    const OAuthState = crypto.randomBytes(32).toString('hex');

    dispatch({ type: SET_CODE_VERIFIER, payload: verifier });
    dispatch({ type: SET_AUTH_STATE, payload: OAuthState });

    const sha256 = (buffer) => crypto.createHash('sha256').update(buffer).digest();

    setChallenge(base64URLEncode(sha256(verifier)));
    setAuthState(OAuthState);
  }, [crypto, dispatch]);

  if (loadingRedirect) {
    return (
      <>
        <div className={styles.loadingScreen}>
          <Spinner text={RegisterPageContent.loadingRedirectText} />
        </div>
      </>
    );
  }

  return (
    <div className="coop-l-container">
      <div className={`${styles.register_page} register-page coop-l-medium-12 coop-l-large-12`}>
        <AlertMessage />
        <div className={`${styles.register_grid}`}>
          <div className={`${styles.left_column} coop-l-medium-12 coop-l-large-12`}>
            <ul className={styles.info_container}>
              <h1 className={`${styles.header}`}>{RegisterPageContent.headingText}</h1>
              <h2 className={styles.info_container__header}>{RegisterPageContent.infoHeadingText}</h2>
              {isP9 ? (
                <>
                  <li className="coop-l-row">
                    <p className={`${styles.info_container__paragraph} coop-l-column`}>
                      <img className={styles.info_container__icon} src={checkCircleGreen} alt="check circle" />
                      {RegisterPageContent.isP9.infoText1}
                    </p>
                  </li>
                  <li className="coop-l-row">
                    <p className={`${styles.info_container__paragraph} coop-l-column`}>
                      <img className={styles.info_container__icon} src={checkCircleGreen} alt="check circle" />
                      {RegisterPageContent.isP9.infoText2}
                    </p>
                  </li>
                  <li className="coop-l-row">
                    <p className={`${styles.info_container__paragraph} coop-l-column`}>
                      <img className={styles.info_container__icon} src={checkCircleGreen} alt="check circle" />
                      {RegisterPageContent.isP9.infoText3}
                    </p>
                  </li>
                </>
              ) : (
                <>
                  <li className="coop-l-row">
                    <p className={`${styles.info_container__paragraph} coop-l-column`}>
                      {RegisterPageContent.isP5.infoText1}
                    </p>
                  </li>
                </>
              )}
              <div
                id="integrationlink"
                onClick={() => {
                  setLoadingRedirect(true);
                  postLog(NHS_LOGIN_REGISTRATION_START);
                  setTimeout(() => {
                    window.location.href =
                      window.NHS_URL +
                      '/authorize?client_id=' +
                      window.NHS_CLIENTID +
                      '&response_type=code&scope=openid%20profile%20profile_extended%20gp_integration_credentials%20email%20phone&state=' +
                      authState +
                      '&nonce=456&redirect_uri=' +
                      window.NHS_REDIRECT_URI +
                      '&vtr=' +
                      (isP9 ? NHS_VTR_CODE_P9 : NHS_VTR_CODE_P5) +
                      '&code_challenge_method=S256&code_challenge=' +
                      challenge;
                  }, redirectDelay);
                }}
                className={styles.nhs_container}>
                <NHSLogo />
              </div>
            </ul>
            <p dangerouslySetInnerHTML={{ __html: RegisterPageContent.externalLinksHTML }} />
          </div>
          <div className={styles.promo_image}>
            <img src={hpPromo} alt="Hey Pharmacist" />
          </div>
        </div>
      </div>
    </div>
  );
};

Register.propTypes = {
  isP9: PropTypes.bool.isRequired,
};

Register.defaultProps = {
  isP9: true,
};

export default Register;
